/*
 * @Descripttion:
 * @version:
 * @Author: wanglikun
 * @Date: 2022-10-17 10:17:48
 * @LastEditors: sueRimn
 * @LastEditTime: 2022-11-13 10:38:05
 */
import { RouteRecordRaw } from 'vue-router'
const BoxView = () => import('@jms/views/boxManage/boxList/Index.vue')
const WorkBench = () => import('@jms/views/boxManage/boxList/workBench/Index.vue')
const BoxSetting = () => import('@jms/views/boxManage/boxList/boxSetting/Index.vue')
const BoxLog = () => import('@jms/views/boxManage/boxList/boxLog/Index.vue')
const BoxInstall = () => import('@/views/boxInstall/Index.vue')
const CourierManager = () => import('@jms/views/boxManage/courierManager/Index.vue')
const LatticePortSummary = () => import('@jms/views/boxManage/latticePortSummary/Index.vue')
const DeliverOrder = () => import('@jms/views/searchList/deliverOrder/Index.vue')
const NoticeRecord = () => import('@jms/views/searchList/noticeRecord/Index.vue')
const SerderOrder = () => import('@jms/views/searchList/serderOrder/Index.vue')
const StorageOrder = () => import('@jms/views/searchList/storageOrder/Index.vue')

const User = () => import('@jms/views/systemManager/user/Index.vue')
const Config = () => import('@jms/views/systemManager/config/Index.vue')
const Role = () => import('@jms/views/systemManager/role/Index.vue')
const Menu = () => import('@jms/views/systemManager/menu/Index.vue')
const DicData = () => import('@jms/views/systemManager/dicData/Index.vue')
const Distributor = () => import('@/views/distributor/index.vue')
const HardwareModel = () => import('@jms/views/systemManager/HardwareModel/Index.vue')
const DeviceCode = () => import('@jms/views/systemManager/deviceCode/Index.vue')

const CourierWallet = () => import('@jms/views/finance/courierWallet/Index.vue')
const BoxIncomeAndOut = () => import('@jms/views/finance/boxIncomeAndOut/Index.vue')
const DistributorWallet = () => import('@jms/views/finance/distributorWallet/Index.vue')
const DistributorWalletDetail = () => import('@jms/views/finance/distributorWalletDetail/Index.vue')
const HistoryBalance = () => import('@jms/views/finance/historyBalance/Index.vue')
const OnlineOrderRecord = () => import('@jms/views/finance/onlineOrderRecord/Index.vue')
const CodFeeDetail = () => import('@jms/views/finance/codFeeDetail/Index.vue')
const BoxFeeDetail = () => import('@jms/views/finance/boxFeeDetail/Index.vue')

const Price = () => import('@jms/views/operationManager/price/Index.vue')
const SmsPrice = () => import('@jms/views/operationManager/smsPrice/Index.vue')
const BusinessStatistics = () => import('@jms/views/reportCenter/Index.vue')


const boxManagement: RouteRecordRaw[] = [
  {
    path: 'boxList',
    name: 'BoxView',
    component: BoxView,
    meta: { title: '快递柜列表', requiresAuth: true, keepAlive: true }
  },
  {
    path: 'workBench',
    name: 'WorkBench',
    component: WorkBench,
    meta: { title: '可视化工作台', requiresAuth: true, keepAlive: true }
  },
  {
    path: 'boxSetting',
    name: 'BoxSetting',
    component: BoxSetting,
    meta: { title: '快递柜设置', requiresAuth: true, keepAlive: true }
  },
  {
    path: 'boxLog',
    name: 'BoxLog',
    component: BoxLog,
    meta: { title: '快递柜日志', requiresAuth: true, keepAlive: true }
  },
  {
    path: 'boxInstall',
    name: 'BoxInstall',
    component: BoxInstall,
    meta: { title: '快递柜安装', requiresAuth: true, keepAlive: true }
  },
  {
    path: 'courierManager',
    name: 'CourierManager',
    component: CourierManager,
    meta: { title: '快递员管理', requiresAuth: true, keepAlive: true }
  },
  {
    path: 'latticePortSummary',
    name: 'LatticePortSummary',
    component: LatticePortSummary,
    meta: { title: '格口汇总', requiresAuth: true, keepAlive: true }
  }
]
const searchList: RouteRecordRaw[] = [
  {
    path: '/deliverOrder',
    name: 'DeliverOrder',
    component: DeliverOrder,
    meta: { title: '派件订单', requiresAuth: true, keepAlive: true }
  },
  {
    path: '/serderOrder',
    name: 'SerderOrder',
    component: SerderOrder,
    meta: { title: '寄件订单', requiresAuth: true, keepAlive: true }
  },
  {
    path: '/storageOrder',
    name: 'StorageOrder',
    component: StorageOrder,
    meta: { title: '储物订单', requiresAuth: true, keepAlive: true }
  },
  {
    path: '/noticeRecord',
    name: 'NoticeRecord',
    component: NoticeRecord,
    meta: { title: '通知记录', requiresAuth: true, keepAlive: true }
  }
]

const systemManager: RouteRecordRaw[] = [
  {
    path: '/user',
    name: 'User',
    component: User,
    meta: { title: '后台用户', requiresAuth: true, keepAlive: true }
  },
  {
    path: '/role',
    name: 'Role',
    component: Role,
    meta: { title: '角色管理', requiresAuth: true, keepAlive: true }
  },
  {
    path: '/menu',
    name: 'Menu',
    component: Menu,
    meta: { title: '菜单管理', requiresAuth: true, keepAlive: true }
  },
  {
    path: '/dicData',
    name: 'DicData',
    component: DicData,
    meta: { title: '数据字典', requiresAuth: true, keepAlive: true }
  },
  {
    path: '/distributor',
    name: 'Distributor',
    component: Distributor,
    meta: { title: '渠道商管理', requiresAuth: true, keepAlive: true }
  },
  {
    path: '/HardwareModel',
    name: 'HardwareModel',
    component: HardwareModel,
    meta: { title: '硬件型号', requiresAuth: true, keepAlive: true }
  },
  {
    path: '/deviceCode',
    name: 'DeviceCode',
    component: DeviceCode,
    meta: { title: '设备编码', requiresAuth: true, keepAlive: true }
  },
  {
    path: '/config',
    name: 'Config',
    component: Config,
    meta: { title: '云云专属', requiresAuth: true, keepAlive: true }
  }
]
const financeManager: RouteRecordRaw[] = [
  {
    path: '/courierWallet',
    name: 'CourierWallet',
    component: CourierWallet,
    meta: { title: '快递员钱包', requiresAuth: true, keepAlive: true }
  },
  {
    path: '/boxIncomeAndOut',
    name: 'BoxIncomeAndOut',
    component: BoxIncomeAndOut,
    meta: { title: '快递柜收支', requiresAuth: true, keepAlive: true }
  },
  {
    path: '/distributorWallet',
    name: 'DistributorWallet',
    component: DistributorWallet,
    meta: { title: '渠道商钱包', requiresAuth: true, keepAlive: true }
  },
  {
    path: '/distributorWalletDetail',
    name: 'DistributorWalletDetail',
    component: DistributorWalletDetail,
    meta: { title: '收支明细', requiresAuth: true, keepAlive: true }
  },
  {
    path: '/historyBalance',
    name: 'HistoryBalance',
    component: HistoryBalance,
    meta: { title: '历史余额', requiresAuth: true, keepAlive: true }
  },
  {
    path: '/onlineOrderRecord',
    name: 'OnlineOrderRecord',
    component: OnlineOrderRecord,
    meta: { title: '在线交易订单记录', requiresAuth: true, keepAlive: true }
  },
  {
    path: '/codFeeDetail',
    name: 'CodFeeDetail',
    component: CodFeeDetail,
    meta: { title: 'COD费用明细', requiresAuth: true, keepAlive: true }
  },
  {
    path: '/boxFeeDetail',
    name: 'BoxFeeDetail',
    component: BoxFeeDetail,
    meta: { title: '快递柜费用明细', requiresAuth: true, keepAlive: true }
  }
]
const operationManager: RouteRecordRaw[] = [
  {
    path: '/price',
    name: 'Price',
    component: Price,
    meta: { title: '价格配置', requiresAuth: true, keepAlive: true }
  },
  {
    path: '/smsPrice',
    name: 'SmsPrice',
    component: SmsPrice,
    meta: { title: '短信费价格', requiresAuth: true, keepAlive: true }
  }
]
const businessStatistics: RouteRecordRaw[] = [
  {
    path: '/businessStatistics',
    name: 'BusinessStatistics',
    component: BusinessStatistics,
    meta: { title: '业务统计', requiresAuth: true, keepAlive: true }
  }
]
export { boxManagement, searchList, systemManager, financeManager, operationManager, businessStatistics }
